module.exports = __webpack_public_path__ + "static/media/p19.1ef1bfee.jpeg";